<template>
    <l-layout class="l-tab-page">
        <template #left>
            <l-panel style="padding-right:0;" >
                <template #title>
                    {{$t('历史对话')}} 
                    <div class="tree-setting-btn" v-if="!!messageId" >
                        <el-tooltip effect="dark" content="删除对话" placement="top">
                            <el-button @click="handleChatRemoveClick" type="text" icon="el-icon-remove-outline"></el-button>
                        </el-tooltip>
                    </div>
                </template>
                <el-tree v-loading="treeLoading" ref="history" :data="historyOptions" node-key="f_Id"  @node-click="handleNodeClick">
                    <span class="lr-tree-node"  slot-scope="{ node}">
                        <i class="el-icon-notebook-2"></i>
                        {{ $t(node.label) }}
                    </span>
                </el-tree>
            </l-panel>
        </template>
        <l-panel style="padding-left:0;" >
            <template #toolLeft >
                <div class="l-panel--item" >
                    <l-tree-select :disabled="loading" :clearable="false" :placeholder="$t('请选择AI平台')" :options="platformOptions" @change="hanleSearch" v-model="platformId" size="mini" >
                    </l-tree-select>
                </div>
                <div class="l-panel--item" >
                    <el-input :disabled="loading" :placeholder="$t('请输入编码/名称')"  @keyup.enter.native="hanleSearch" v-model="searchWord" size="mini" >
                        <el-button @click="hanleSearch" slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </div>
            </template>
            <template #toolRight >
                <l-tool-btns :hasAdd="false" :hasRefresh="false">
                    <el-button-group>
                        <el-button v-if="changedState" :disabled="loading" type="primary" size="mini" icon="el-icon-files" @click="handleClick('Save')">保存对话</el-button>
                    </el-button-group>
                    <el-button-group>
                        <el-button type="primary" :disabled="loading" size="mini" icon="el-icon-plus" @click="handleClick('Add')">新建对话</el-button>
                    </el-button-group>
                </l-tool-btns>
            </template>
            <l-ai-chat-box ref="chat" v-model="msgList" @change="changedState=true" :platformId="platformId"
                 @loading="handleLoading"></l-ai-chat-box>
        </l-panel>
    </l-layout>
</template>
<script>


export default {
    name:'l-ai-chat-list',
    components: {
        
    },
    props: {
    },
    data () {
        return {
            treeLoading:false,
            //查询
            searchWord:'', 
            historyOptions: [],
            platformOptions: [],
            
            changedState:false,
            msgList:[],
            loading: false,
            platformId: '',
            messageId: ''
        };
    },
    computed:{
    },
    mounted () {
        this.loadPlatform()
        this.loadHistory()
    },
    methods:{
        handleChatRemoveClick(){
            this.$confirm(this.$t('此操作将永久删除该对话, 是否继续?'), this.$t('提示'), {
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'warning'
                }).then(() => {
                    const api = window.$api.ai.platform
                    api.removemessages(this.messageId).then(()=>{
                        this.$message.success('删除成功')
                        this.loadHistory()
                    }).catch(()=>{

                    })                 
                }).catch(() => {
                    this.$message.info('已取消删除!')
                })
        },
        handleLoading(loading){
            this.historyOptions.forEach(item=>{
                item.disabled = loading
            })
            this.treeLoading = loading
            this.loading = loading
        },
        loadPlatform(){
            const api = window.$api.ai.platform
            api.getselect().then(res=>{
                var data = res.data.data
                data = data.map(t=>{ return { ...t, value: t.f_Id, label: t.f_FullName}})
                this.platformOptions = this.$toTree(data, 'f_Id', 'f_ParentId', 'f_Id', 'f_FullName')                 
                if(this.platformOptions.length > 0){
                    this.platformId = this.platformOptions[0].f_Id;
                }
            }).catch(()=>{

            })
        },
        loadHistory(){
            this.treeLoading = true
            this.messageId = ''
            const api = window.$api.ai.platform
            api.history(this.loginInfo.f_UserId).then(res=>{
                var data = res.data.data
                data = data.map(t=>{ return { ...t, value: t.f_Id, label: t.f_Content}})
                this.historyOptions = this.$toTree(data, 'f_Id', 'f_ParentId', 'f_Id', 'f_Content') 
                this.treeLoading = false
            }).catch(()=>{
                this.treeLoading = false
            })
        },
        loadChatMessages(id){
            const api = window.$api.ai.platform
            api.getmessages(id).then(res=>{
                this.msgList = res.data.data.sort((a,b)=>{return Date.parse(a.f_CreateDate) - Date.parse(b.f_CreateDate)})
            }).catch(()=>{

            })
        },
        handleNodeClick(data) {
            this.messageId = data.value
            this.changedState = false
            this.loadChatMessages(data.value);
        },
        hanleSearch(){
            this.loadChatMessages()
        },
        handleClick(item){
            if(item == 'Add'){
                this.loading = false
                this.changedState = false
                this.$refs.history.setCurrentKey(null)
                this.msgList = []
                this.messageId = ''
            }else{
                const api = window.$api.ai.platform
                api.addmessages({chatMessages: this.msgList}).then(()=>{
                    this.changedState = false
                    this.msgList = []
                    this.loadHistory()
                }).catch(()=>{

                })
            }
        }
    }
}
</script>
